var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gif-player" }, [
    _c(
      "video",
      {
        ref: "player",
        attrs: {
          loop: _vm.loop,
          muted: "",
          playsinline: "",
          poster: _vm.still,
          width: _vm.width,
          height: _vm.height,
        },
        domProps: { muted: true },
        on: {
          play: _vm.onPlay,
          pause: _vm.onPause,
          canplay: _vm.onCanPlay,
          waiting: _vm.onWaiting,
          loadeddata: _vm.onLoad,
        },
      },
      [
        _vm.type === "video"
          ? _c("source", { attrs: { src: _vm.src, type: "video/mp4" } })
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _vm.loaded
      ? _c("div", [
          !_vm.playing
            ? _c("div", { staticClass: "YnXDvQvpM OOKpgQoKM" })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              class: "gGVvBwZGQ OOKpgQoKM " + _vm.loadingClass,
              on: { click: _vm.onToggle },
            },
            [
              !_vm.playing
                ? _c("div", { staticClass: "zqxOjvMAN" }, [_vm._m(0)])
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.showBy
            ? _c("div", [
                !_vm.playing
                  ? _c(
                      "a",
                      {
                        staticClass: "vmDOAnrkZ",
                        attrs: { href: _vm.defaultBy.url, target: "_blank" },
                      },
                      [
                        _c("span", { staticClass: "BxKNmZlVJ" }, [
                          _vm._v(_vm._s(_vm.defaultBy.name)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                              version: "1.1",
                              width: "22",
                              height: "24",
                              viewBox: "0 0 24 24",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "#fff",
                                d: "M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z",
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "btn-play" }, [
      _c("span", { staticClass: "btn-play-text" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }